var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.mostrarHistoricos }
              },
              [
                _c("i", { staticClass: "fa fa-history" }),
                _c("span", [_vm._v("Historial")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("E")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Excel")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-danger",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.exportarDocumento("P")
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-file-pdf-o" }),
                _c("span", [_vm._v("PDF")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-2" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-8" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "H" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "H") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "H")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Hoy")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "A" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Ayer")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoFecha,
                        expression: "form.tipoFecha"
                      }
                    ],
                    attrs: { type: "radio", value: "P" },
                    domProps: { checked: _vm._q(_vm.form.tipoFecha, "P") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoFecha", "P")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Personalizado")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaDesde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaDesde", $$v)
                            },
                            expression: "form.fechaDesde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Desde:")])
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.tipoFecha == "P",
                        expression: "form.tipoFecha == 'P'"
                      }
                    ],
                    staticClass: "form-field"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "desde",
                            locale: "es",
                            "only-date": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fechaHasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fechaHasta", $$v)
                            },
                            expression: "form.fechaHasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Hasta:")])
                      ],
                      1
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2 select2-field--stretch",
                  class: { "select2--disabled": !_vm.administraTodasBodegas }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          filterable: false,
                          label: "descripcion",
                          placeholder: "Seleccione...",
                          options: _vm.optionsBodegas,
                          id: "bodegas"
                        },
                        on: { input: _vm.inputBodega },
                        model: {
                          value: _vm.selectedBodega,
                          callback: function($$v) {
                            _vm.selectedBodega = $$v
                          },
                          expression: "selectedBodega"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "bodegas" } }, [
                        _vm._v("Sucursal:")
                      ])
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-3 mt-2" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoValores,
                        expression: "form.tipoValores"
                      }
                    ],
                    attrs: { type: "radio", value: "C" },
                    domProps: { checked: _vm._q(_vm.form.tipoValores, "C") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoValores", "C")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Cantidades")])
                ]),
                _vm._v(" "),
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoValores,
                        expression: "form.tipoValores"
                      }
                    ],
                    attrs: { type: "radio", value: "M" },
                    domProps: { checked: _vm._q(_vm.form.tipoValores, "M") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoValores", "M")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Montos")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-9" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        filterable: false,
                        label: "nombre",
                        placeholder: "Seleccione...",
                        options: _vm.optionsRutas,
                        id: "rutas",
                        multiple: ""
                      },
                      on: { search: _vm.onSearchRutas, input: _vm.inputRutas },
                      model: {
                        value: _vm.selectedRutas,
                        callback: function($$v) {
                          _vm.selectedRutas = $$v
                        },
                        expression: "selectedRutas"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "rutas" } }, [_vm._v("Rutas:")])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.registros.length > 0
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.nombreBodega != null && _vm.nombreBodega != "",
                          expression:
                            "nombreBodega != null && nombreBodega != ''"
                        }
                      ],
                      staticClass: "form-field"
                    },
                    [
                      _c("h6", [
                        _vm._v(_vm._s("SUCURSAL: " + _vm.nombreBodega))
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c("table", { staticClass: "table--bordered" }, [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                },
                                attrs: { colspan: "2" }
                              },
                              [
                                _vm._v(
                                  "\n                    DIAS DE LA SEMANA\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.fechas, function(fecha, index) {
                              return _c(
                                "th",
                                {
                                  key:
                                    index.toString() +
                                    _vm
                                      .moment(new Date())
                                      .format("YYYYMMDDHHmmss") +
                                    "fecha",
                                  staticStyle: {
                                    "font-size": "11px",
                                    "background-color": "#f3f2f2"
                                  },
                                  attrs: {
                                    colspan: _vm.agruparSemanal ? "3" : "4"
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        fecha.fecha_pedido +
                                          " " +
                                          fecha.dia_semana
                                      )
                                    )
                                  ])
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm._m(1),
                            _vm._v(" "),
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.agruparSemanal,
                                    expression: "!agruparSemanal"
                                  }
                                ],
                                staticStyle: {
                                  "font-size": "11px",
                                  "background-color": "#e8e7e7"
                                },
                                attrs: { rowspan: "2" }
                              },
                              [_c("b", [_vm._v("TOTAL SUPERV.")])]
                            ),
                            _vm._v(" "),
                            _vm._m(3)
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "tr",
                          [
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    #\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "font-size": "10px",
                                  "background-color": "#f3f2f2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    RUTA\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.indicesFechasX2, function(
                              indiceFecha,
                              index2
                            ) {
                              return _c(
                                "th",
                                {
                                  key:
                                    index2.toString() +
                                    _vm
                                      .moment(new Date())
                                      .format("YYYYMMDDHHmmss") +
                                    "activas",
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#e8e7e7"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: indiceFecha.tipo == "A",
                                          expression: "indiceFecha.tipo == 'A'"
                                        }
                                      ]
                                    },
                                    [_vm._v("ACTIVAS")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: indiceFecha.tipo == "N",
                                          expression: "indiceFecha.tipo == 'N'"
                                        }
                                      ]
                                    },
                                    [_vm._v("NUEVAS")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: indiceFecha.tipo == "S",
                                          expression: "indiceFecha.tipo == 'S'"
                                        }
                                      ]
                                    },
                                    [_vm._v("SUPERV.")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: indiceFecha.tipo == "T",
                                          expression: "indiceFecha.tipo == 'T'"
                                        }
                                      ]
                                    },
                                    [_vm._v("TOTAL")]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.registros, function(registro, index3) {
                            return _c(
                              "tr",
                              {
                                key:
                                  index3.toString() +
                                  _vm
                                    .moment(new Date())
                                    .format("YYYYMMDDHHmmss") +
                                  "reg"
                              },
                              [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "font-size": "10px",
                                      "background-color": "#f3f2f2"
                                    }
                                  },
                                  [_c("b", [_vm._v(_vm._s(index3 + 1))])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(registro.ruta_nombre) +
                                        "\n                  "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.indicesRegistrosX2, function(
                                  indiceRegistro,
                                  index4
                                ) {
                                  return _c(
                                    "td",
                                    {
                                      key:
                                        index4.toString() +
                                        _vm
                                          .moment(new Date())
                                          .format("YYYYMMDDHHmmss") +
                                        "detalle",
                                      staticStyle: { "font-size": "10px" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: indiceRegistro.tipo == "A",
                                              expression:
                                                "indiceRegistro.tipo == 'A'"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formatear(
                                                  registro.detalles[
                                                    indiceRegistro.i
                                                  ].cantidad_activas
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: indiceRegistro.tipo == "N",
                                              expression:
                                                "indiceRegistro.tipo == 'N'"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formatear(
                                                  registro.detalles[
                                                    indiceRegistro.i
                                                  ].cantidad_nuevas
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: indiceRegistro.tipo == "S",
                                              expression:
                                                "indiceRegistro.tipo == 'S'"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formatear(
                                                  registro.detalles[
                                                    indiceRegistro.i
                                                  ].cantidad_supervisadas
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: indiceRegistro.tipo == "T",
                                              expression:
                                                "indiceRegistro.tipo == 'T'"
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.formatear(
                                                  registro.detalles[
                                                    indiceRegistro.i
                                                  ].cantidad_activas,
                                                  registro.detalles[
                                                    indiceRegistro.i
                                                  ].cantidad_nuevas,
                                                  registro.detalles[
                                                    indiceRegistro.i
                                                  ].cantidad_supervisadas
                                                )
                                              ) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatear(registro.total_activas)
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatear(registro.total_nuevas)
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.agruparSemanal,
                                        expression: "!agruparSemanal"
                                      }
                                    ],
                                    staticStyle: { "font-size": "10px" }
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatear(
                                            registro.total_supervisadas
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "font-size": "10px" } },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatear(
                                            registro.total_nuevas,
                                            registro.total_activas,
                                            registro.total_supervisadas
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "tr",
                            [
                              _vm._m(4),
                              _vm._v(" "),
                              _vm._m(5),
                              _vm._v(" "),
                              _vm._l(_vm.indicesRegistrosX2, function(
                                indiceRegistro,
                                index4
                              ) {
                                return _c(
                                  "td",
                                  {
                                    key:
                                      index4.toString() +
                                      _vm
                                        .moment(new Date())
                                        .format("YYYYMMDDHHmmss") +
                                      "detalle",
                                    staticStyle: {
                                      "font-size": "10px",
                                      "background-color": "#f3f2f2"
                                    }
                                  },
                                  [
                                    _c(
                                      "b",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: indiceRegistro.tipo == "A",
                                            expression:
                                              "indiceRegistro.tipo == 'A'"
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.formatear(
                                                _vm.fechasTotales[
                                                  indiceRegistro.i
                                                ].cantidad_activas
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: indiceRegistro.tipo == "N",
                                            expression:
                                              "indiceRegistro.tipo == 'N'"
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.formatear(
                                                _vm.fechasTotales[
                                                  indiceRegistro.i
                                                ].cantidad_nuevas
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: indiceRegistro.tipo == "S",
                                            expression:
                                              "indiceRegistro.tipo == 'S'"
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.formatear(
                                                _vm.fechasTotales[
                                                  indiceRegistro.i
                                                ].cantidad_supervisadas
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: indiceRegistro.tipo == "T",
                                            expression:
                                              "indiceRegistro.tipo == 'T'"
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.formatear(
                                                _vm.fechasTotales[
                                                  indiceRegistro.i
                                                ].cantidad_activas,
                                                _vm.fechasTotales[
                                                  indiceRegistro.i
                                                ].cantidad_nuevas,
                                                _vm.fechasTotales[
                                                  indiceRegistro.i
                                                ].cantidad_supervisadas
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.formatear(_vm.totalActivas))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(_vm.formatear(_vm.totalNuevas))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.agruparSemanal,
                                      expression: "!agruparSemanal"
                                    }
                                  ],
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatear(_vm.totalSupervisadas)
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    "font-size": "10px",
                                    "background-color": "#f3f2f2"
                                  }
                                },
                                [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatear(
                                          _vm.totalActivas,
                                          _vm.totalNuevas,
                                          _vm.totalSupervisadas
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            2
                          )
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "historicos",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [_c("reportes-historicos-excel", { attrs: { tipoReporte: "ct" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Reporte de cuadre de tarjetas")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: { "font-size": "11px", "background-color": "#e8e7e7" },
        attrs: { rowspan: "2" }
      },
      [_c("b", [_vm._v("TOTAL ACTIVAS")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: { "font-size": "11px", "background-color": "#e8e7e7" },
        attrs: { rowspan: "2" }
      },
      [_c("b", [_vm._v("TOTAL NUEVAS")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "th",
      {
        staticStyle: { "font-size": "11px", "background-color": "#e8e7e7" },
        attrs: { rowspan: "2" }
      },
      [_c("b", [_vm._v("TOTAL TARJETAS")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticStyle: { "font-size": "10px", "background-color": "#f3f2f2" } },
      [_c("b", [_vm._v("*")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      { staticStyle: { "font-size": "10px", "background-color": "#f3f2f2" } },
      [_c("b", [_vm._v("TOTAL")])]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5572ba8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5572ba8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteCuadreTarjeta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5572ba8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ReporteCuadreTarjeta.vue
// module chunks = 0